import React from 'react';
import { Zap } from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      {/* Mobile-only: 10 Free Credits badge */}
      <div className="md:hidden flex justify-center pt-6 pb-2">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-brand-900/40 rounded-full border-2 border-brand-500/50 shadow-md shadow-brand-500/20">
          <Zap size={14} className="text-brand-400 fill-brand-400 shrink-0" />
          <span className="font-bold text-brand-200 text-xs whitespace-nowrap">10 HDR Credits / month</span>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-3 flex items-center gap-2">
              <img src="/hdr-photo-logo.png" alt="HDR Photo Studio" className="h-9 w-auto object-contain object-left" />
              <span className="text-sm font-semibold text-white">HDR Photo Studio</span>
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Professional HDR processing and AI enhancement for real estate photographers. Smart bracket detection,
              automatic stacking, and stunning results.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold text-brand-400 uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Smart HDR stacking</li>
              <li>Window pull</li>
              <li>Colour and white balance</li>
              <li>Vertical correction</li>
              <li>Batch listing upload</li>
            </ul>
          </div>

          {/* Pricing */}
          <div>
            <h4 className="text-xs font-semibold text-brand-400 uppercase tracking-wider mb-3">Pricing</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full" />
                10 HDR Credits / month free
              </li>
              <li>1 HDR Credit = 1 edit</li>
              <li>Monthly HDR Credit plans</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-brand-400 uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-brand-400 transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/partner" className="hover:text-brand-400 transition-colors">
                  Partner Programme
                </a>
              </li>
              <li>
                <a href="#ask-ai" className="hover:text-brand-400 transition-colors">
                  Ask AI about HDR Photo
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/contact" className="hover:text-brand-400 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://www.rehub.studio/terms-conditions" target="_blank" rel="noopener noreferrer" className="hover:text-brand-400 transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://www.rehub.studio/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-brand-400 transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            &copy; {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">&middot;</span>
            <span>10 HDR Credits / month free</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
